import styled from "styled-components";

export const Container = styled.div`
  margin: auto;
  margin-top: 40px;
  margin-bottom: 40px;
  height: fit-content;
  width: 90vw;
`;

export const Title = styled.div`
  width: fit-content;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 25px;
  font: normal normal 600 20px Open Sans;
  color: ${({ theme }) => {
    return theme.colors.title;
  }};
`;
